module.exports = __webpack_public_path__ + "img/back invisible zipper length.538d680e.png";